import { useCallback, useMemo } from 'react';
import { ShareToolFormContainer, ShareToolTabLeftSection, ShareToolTabRightSection } from './ShareToolLayout';
import { ShareToolTabFooter } from './ShareToolTabFooter';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { standaloneTrackInteraction } from '../../usage-tracker/standaloneTrack';
import { ToolPreview } from './ToolPreview';
import { ShareToolCloseButton } from './ShareToolCloseButton';
import { HR } from 'foundations-components/transitional/components/HR';
// @ts-expect-error bender-url not typed
import paymentMethodsPng from 'bender-url!commerce-tools-ui-lib/images/payment_methods.png';
import { getPaymentsEnrollmentUrl } from '../../utils/urls';
import { Alert } from 'foundations-components/transitional/components/Alert';
import DataTransferTab from 'payments-post-enroll-local-storage-lib/components/DataTransferTab';
import { ExternalLinkIcon } from 'foundations-assets';
import { Text } from 'foundations-components/components/Text';
import { Media } from 'foundations-components/transitional/components/Media';
import { MediaBody } from 'foundations-components/transitional/components/MediaBody';
import { MediaRight } from 'foundations-components/transitional/components/MediaRight';
import { Image } from 'foundations-components/transitional/components/Image';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const TestCheckoutShareTab = ({
  description,
  checkoutPreviewProps,
  buttonProps,
  knowledgeBaseLink,
  paymentsUnderwritingStatus,
  previewComponent,
  previewScale
}) => {
  const handleSetupPaymentsButtonClick = useCallback(() => {
    standaloneTrackInteraction({
      action: 'click set up online payments button'
    });
  }, []);
  const setupPaymentsSection = useMemo(() => {
    switch (paymentsUnderwritingStatus) {
      case 'IN_UNDERWRITING':
      case 'IN_KYC':
        return /*#__PURE__*/_jsx(Alert, {
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "CommerceToolsUiLib.shareToolModal.testCheckoutTab.infoAlertTitle"
          }),
          type: "info",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "CommerceToolsUiLib.shareToolModal.testCheckoutTab.infoAlertBody"
          })
        });
      case 'APPROVED':
        return null;
      default:
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(Media, {
            children: [/*#__PURE__*/_jsx(MediaBody, {
              children: /*#__PURE__*/_jsx(Text, {
                as: "h5",
                marginBlockEnd: "400",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "CommerceToolsUiLib.shareToolModal.testCheckoutTab.setupHeader"
                })
              })
            }), /*#__PURE__*/_jsx(MediaRight, {
              children: /*#__PURE__*/_jsx(Image, {
                src: paymentMethodsPng,
                maxBlockSize: "25px"
              })
            })]
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "CommerceToolsUiLib.shareToolModal.testCheckoutTab.setupSubheader"
            })
          }), /*#__PURE__*/_jsx(Button, {
            use: "primary",
            href: getPaymentsEnrollmentUrl(),
            onClick: handleSetupPaymentsButtonClick,
            block: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "CommerceToolsUiLib.shareToolModal.testCheckoutTab.setupButton"
            })
          })]
        });
    }
  }, [handleSetupPaymentsButtonClick, paymentsUnderwritingStatus]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ShareToolTabLeftSection, {
      children: /*#__PURE__*/_jsxs(ShareToolFormContainer, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "p",
          marginBlockEnd: knowledgeBaseLink ? '300' : '400',
          children: description
        }), knowledgeBaseLink && /*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "300",
          as: "p",
          children: knowledgeBaseLink
        }), /*#__PURE__*/_jsx(DataTransferTab, {
          tabUrl: checkoutPreviewProps.url,
          data: checkoutPreviewProps.data,
          fromLocation: checkoutPreviewProps.fromLocation,
          children: onClick => /*#__PURE__*/_jsxs(Button, {
            block: true,
            use: "tertiary",
            "data-test-id": buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps['data-test-id'],
            "data-tour-id": buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps['data-tour-id'],
            onClick: event => {
              var _buttonProps$onClick;
              standaloneTrackInteraction({
                action: 'click test checkout button'
              });
              onClick(event);
              buttonProps === null || buttonProps === void 0 || (_buttonProps$onClick = buttonProps.onClick) === null || _buttonProps$onClick === void 0 || _buttonProps$onClick.call(buttonProps, event);
            },
            children: [(buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.label) || /*#__PURE__*/_jsx(FormattedMessage, {
              message: "CommerceToolsUiLib.shareToolModal.testCheckoutTab.textCheckoutButton"
            }), /*#__PURE__*/_jsx(ExternalLinkIcon, {
              size: "400"
            })]
          })
        }), setupPaymentsSection && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(HR, {}), setupPaymentsSection]
        })]
      })
    }), /*#__PURE__*/_jsx(ShareToolTabRightSection, {
      children: /*#__PURE__*/_jsx(ToolPreview, {
        scale: previewScale,
        children: previewComponent
      })
    }), /*#__PURE__*/_jsx(ShareToolTabFooter, {
      children: /*#__PURE__*/_jsx(ShareToolCloseButton, {})
    })]
  });
};